import {Action, Module} from 'vuex-module-decorators';
import store from '@/store';
import {FaqModel} from '@/models/faq.model';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import {EntityStateAdapter} from '@/store/base.store';

export const featureKey = 'faqs';

// @ts-ignore
if (store.state.faqs) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class FaqsStoreModule extends EntityStateAdapter<FaqModel> {

  @Action({commit: 'insertMany', rawError: true})
  async fetchFaqs(challengerId: number) {
    if (!!this.entities) {
      return this.entities;
    }
    return await (new ChallengesApi())
      .getFaqs(challengerId)
      .pipe(take(1))
      .toPromise()
  }

  get faqs(): FaqModel[] {
    return this._entities;
  }

  get faqCounter(): number {
    return this._entities.length;
  }
}
